module.exports = __webpack_public_path__ + "img/PM_2.357155f3.svg";